

  
const content = `# OnData SecureAI Overview

The OnData SecureAI product enables organizations to leverage the full power of the public GenAI Large Language Models (LLMs) with their internal datasets to gain insights, 
while ensuring all confidential and sensitive data is discovered, classified, and protected to meet data security and data privacy requirements. Using plain language, users 
can ask any questions about their data, monitor data of interest to receive reports and alerts, and automate workflows to process data and documents. OnData SecureAI ensures 
that sensitive data is not revealed to the public GenAI LLMs, and is only accessible to users who are explicitly authorized to access such data. 
  
The SecureAI solution can be deployed to a customer's network environment where customer's data is, either on-premises or in the cloud. Please follow the sections below to 
install, configure, and use the OnData SecureAI solution.

* [**Install and Configure SecureAI**](reference_doc#secureai/installation_and_configuration/overview)
* [**SecureAI for Data Query**](reference_doc#secureai/data_query)
* [**SecureAI for Agent Automation**](reference_doc#secureai/agent_automation)


`
  
export default content;
